import Skeleton from "react-loading-skeleton";

export const ShipMethodSkeleton = () => {
  return (
    <div className="nav nav-pills delivery-method-pills mb-3">
      <div className="nav-item delivery-method-item">
        <div className="nav-link active">
          <Skeleton width={120} height={20} />
          <Skeleton width={100} height={15} />
        </div>
      </div>
      <div className="nav-item delivery-method-item">
        <div className="nav-link">
          <Skeleton width={120} height={20} />
          <Skeleton width={100} height={15} />
        </div>
      </div>
      <div className="nav-item delivery-method-item">
        <div className="nav-link">
          <Skeleton width={120} height={20} />
          <Skeleton width={100} height={15} />
        </div>
      </div>
    </div>
  );
};
